<!-- Breadcrumb -->
<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" href="#">{{ curso.nome }}</a>
          </div>
          <h1 class="title text-white">
            {{ curso.nome }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Breadcrumb end -->

<!-- Detalhes do Curso -->
<div class="rts-course-area rts-section-gap">
  <div class="container">
    <div class="row g-5">
      <div class="col-lg-8 order-cl-1 order-lg-1 order-md-2 order-sm-2 order-2">
        <h5 class="title" *ngIf="curso.filterClass != 'graduacao'">
          Confira os Prazos de Integralização
        </h5>
        <ng-container *ngIf="curso.filterClass != 'graduacao'">
          <div class="course-top-enroll-area">
            <div class="single-course-top">
              <span>4 meses</span>
              <h2 class="title">
                {{ formatCurrency(curso.planos["4"]?.preco) }}
              </h2>

              <a
                [href]="curso.planos['4']?.link"
                class="rts-btn btn-primary with-arrow"
                >Inscreva-se <i class="fa-solid fa-arrow-right"></i
              ></a>
            </div>
            <div class="single-course-top">
              <span>6 meses</span>
              <h2 class="title">
                {{ formatCurrency(curso.planos["6"]?.preco) }}
              </h2>

              <a
                [href]="curso.planos['6']?.link"
                class="rts-btn btn-primary with-arrow"
                >Inscreva-se <i class="fa-solid fa-arrow-right"></i
              ></a>
            </div>
            <div class="single-course-top">
              <span>12 meses</span>
              <h2 class="title">
                {{ formatCurrency(curso.planos["4"]?.preco) }}
              </h2>

              <a
                [href]="curso.planos['12']?.link"
                class="rts-btn btn-primary with-arrow"
                >Inscreva-se <i class="fa-solid fa-arrow-right"></i
              ></a>
            </div>
          </div>
        </ng-container>

        <div class="course-details-btn-wrapper pb--50">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                Informações
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
              >
                Grade Curricular
              </button>
            </li>
          </ul>
        </div>
        <div class="tab-content mt--50" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="course-content-wrapper">
              <h5 class="title">Sobre o Curso</h5>
              <p style="white-space: pre-line">{{ curso.sobre }}</p>
              <h5 class="title">Por que devo escolher esse curso?</h5>
              <p>{{ curso.porqueEscolher }}</p>
              <h5 class="title">
                Quais habilidades terei ao concluir o curso?
              </h5>
              <p>{{ curso.habilidades }}</p>
              <h5 class="title">
                Em quais cargos posso atuar após a formação?
              </h5>
              <p>{{ curso.cargos }}</p>
              <div class="module-wrapper">
                <h6 class="title">O que você vai aprender?</h6>
                <div class="inner-content">
                  <div class="single-wrapper">
                    <div
                      class="single-codule"
                      *ngFor="let item of curso.conteudo.slice(0, 4)"
                    >
                      <i class="fa-solid fa-check"></i>
                      <p>{{ item }}</p>
                    </div>
                  </div>
                  <div class="single-wrapper">
                    <div
                      class="single-codule"
                      *ngFor="let item of curso.conteudo.slice(4, 8)"
                    >
                      <i class="fa-solid fa-check"></i>
                      <p>{{ item }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div class="course-content-wrapper-main">
              <h5 class="title">Disciplinas</h5>

              <!-- Accordion de Disciplinas -->
              <div class="accordion mt--30" id="accordionExample">
                <div
                  class="accordion-item"
                  *ngFor="let disciplina of curso.disciplinas"
                >
                  <h2 class="accordion-header">
                    <button class="accordion-button" type="button">
                      <span>{{ disciplina }}</span>
                    </button>
                  </h2>
                </div>
              </div>
              <!-- Accordion de Disciplinas -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-4 order-cl-2 order-lg-2 order-md-1 order-sm-1 order-1 rts-sticky-column-item"
      >
        <div class="right-course-details">
          <!-- Sidebar -->
          <div class="course-side-bar">
            <div class="thumbnail">
              <img [src]="curso.imagem" [alt]="curso.nome" width="100%" />
            </div>
            <div class="price-area" *ngIf="curso.filterClass == 'graduacao'">
              <h3 class="title">{{ formatCurrency(curso.preco) }}</h3>
              <h4 class="none">
                <s>{{ formatCurrency(curso.precoOriginal) }}</s>
              </h4>
              <span class="discount"
                >-{{
                  calcularDesconto(curso.precoOriginal, curso.preco)
                }}%</span
              >
            </div>

            <a
              *ngIf="curso.filterClass == 'graduacao'"
              [href]="curso.link"
              class="rts-btn btn-primary"
              >Inscreva-se</a
            >
            <a
              *ngIf="curso.filterClass != 'graduacao'"
              [href]="curso.planos['12']?.link"
              class="rts-btn btn-primary"
              >Inscreva-se</a
            >

            <div class="what-includes">
              <span
                class="m text-center"
                *ngIf="curso.filterClass == 'graduacao'"
                >Preços podem variar de acordo com o modelo de ensino e a
                localidade</span
              >
              <h5 class="title">Este curso inclui:</h5>
              <div class="single-include">
                <div class="left">
                  <span>Duração</span>
                </div>
                <div class="right">
                  <span>{{ curso.duracao }}</span>
                </div>
              </div>
              <div class="single-include" *ngIf="curso.grauAcademico">
                <div class="left">
                  <span>Grau Acadêmico</span>
                </div>
                <div class="right">
                  <span>{{ curso.grauAcademico }}</span>
                </div>
              </div>
              <div class="single-include">
                <div class="left">
                  <span>Modalidade</span>
                </div>
                <div class="right">
                  <span>{{ curso.modalidade }}</span>
                </div>
              </div>
              <div
                class="single-include"
                *ngIf="
                  curso.filterClass == 'graduacao';
                  else certificacaoPosGraduacao
                "
              >
                <div class="left">
                  <span>Certificação</span>
                </div>
                <div class="right">
                  <span>Diploma Digital</span>
                </div>
              </div>
              <ng-template #certificacaoPosGraduacao>
                <div class="single-include">
                  <div class="left">
                    <span>Certificação</span>
                  </div>
                  <div class="right">
                    <span>Certificado de Conclusão</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <!-- Sidebar -->
        </div>

        <div class="right-course-details mt--30">
          <div class="course-side-bar">
            <div class="course-single-information">
              <h5 class="title">O material inclui</h5>
              <div class="body">
                <div class="single-check">Aulas gravadas disponíveis 24h</div>
                <div
                  class="single-check"
                  *ngIf="curso.filterClass == 'graduacao'"
                >
                  Aulas ao vivo semanais
                </div>
                <div class="single-check">Seminários e eventos ao vivo</div>
                <div class="single-check">Tutoria Online</div>
                <div class="single-check">Avaliações e provas online</div>
              </div>
            </div>

            <div class="course-single-information">
              <h5 class="title">Compartilhar</h5>
              <div class="body">
                <div class="social-share-course-side-bar">
                  <ul>
                    <li>
                      <a
                        [ngStyle]="{ cursor: 'pointer' }"
                        (click)="share('facebook')"
                        ><i class="fa-brands fa-facebook-f"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        [ngStyle]="{ cursor: 'pointer' }"
                        (click)="share('twitter')"
                        ><i class="fa-brands fa-twitter"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        [ngStyle]="{ cursor: 'pointer' }"
                        (click)="share('linkedin')"
                        ><i class="fa-brands fa-linkedin"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        [ngStyle]="{ cursor: 'pointer' }"
                        (click)="share('whatsapp')"
                        ><i class="fa-brands fa-whatsapp"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-2">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="becom-an-instructor-form-area pt--50 pl--120 pr--120 pl_sm--10 pr_sm--10"
          >
            <form
              [formGroup]="leadForm"
              (ngSubmit)="onSubmit()"
              class="instructor-form"
            >
              <h5 class="title">Fale Conosco</h5>
              <p class="disc">
                Preencha seus dados e entraremos em contato o mais breve
                possível.
              </p>

              <input type="text" placeholder="Nome" formControlName="name" />
              <input
                type="email"
                placeholder="E-mail"
                formControlName="email"
                (input)="onEmailInput($event)"
              />
              <input
                type="text"
                maxlength="20"
                placeholder="Celular"
                formControlName="mobile"
                placeholder="DDD + Celular"
                mask="(00) 00000-0000"
              />

              <button type="submit" class="rts-btn btn-primary mb--30">
                Enviar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Detalhes do Curso -->
